module.exports = new __parcel__URL__("wallet-connect.adc1d7c5.png").toString();